{
  "imports.title": "Veri içe aktar",
  "imports.lede": "Özel bir dışa aktarımı eşle, önerilen her kaydı incele ve yalnızca seçtiklerini uygula.",
  "imports.navigation.label": "Veri içe aktar",
  "imports.navigation.hint": "Diğer araçlardan gelen sınırlı dışa aktarımları incele ve uygula.",
  "imports.error.generic": "İçe aktarma tamamlanamadı.",
  "imports.error.preserved": "Yeni bir şey uygulanmadı. Mevcut çalışman bu sayfada korunuyor.",
  "imports.error.fileTooLarge": "En fazla {{size}} MB boyutunda bir dosya seç.",
  "imports.state.draft": "Taslak",
  "imports.state.needs_input": "Bilgi gerekiyor",
  "imports.state.partially_applied": "Kısmen uygulandı",
  "imports.state.applied": "Uygulandı",
  "imports.state.rejected": "Reddedildi",
  "imports.state.expired": "Süresi doldu",
  "imports.state.superseded": "Yerine yenisi geçti",
  "imports.state.pending": "Bekliyor",
  "imports.state.accepted": "Kabul edildi",
  "imports.family.markdown": "Markdown",
  "imports.family.obsidian": "Obsidian",
  "imports.family.csv": "CSV",
  "imports.family.json": "JSON",
  "imports.family.todoist": "Todoist",
  "imports.family.things": "Things",
  "imports.family.ticktick": "TickTick",
  "imports.family.notion": "Notion",
  "imports.family.apple_health": "Apple Health",
  "imports.family.google_takeout": "Google Takeout",
  "imports.entity.project": "Proje",
  "imports.entity.goal": "Hedef",
  "imports.entity.decision": "Karar",
  "imports.entity.task": "Görev",
  "imports.entity.plan": "Plan",
  "imports.entity.period": "Dönem",
  "imports.entity.routine": "Rutin",
  "imports.entity.note": "Not",
  "imports.entity.knowledge_item": "Bilgi kaydı",
  "imports.entity.journal_entry": "Günlük kaydı",
  "imports.entity.life_item": "Yaşam kaydı",
  "imports.entity.calendar_block": "Takvim bloğu",
  "imports.source.title": "Kaynak",
  "imports.source.description": "Dosya sahibine özel kalır. Önizleme aşağıdaki kayıt sınırını aşmaz.",
  "imports.source.family": "Kaynak türü",
  "imports.source.file": "Dışa aktarım dosyası",
  "imports.source.fileHint": "UTF-8 metin veya desteklenen dışa aktarım arşivi; en fazla {{size}} MB.",
  "imports.source.recordPath": "Kayıt yolu",
  "imports.source.recordPathHint": "JSON dizisine isteğe bağlı RFC 6901 işaretçisi; örneğin /items.",
  "imports.source.delimiter": "Ayraç",
  "imports.source.comma": "Virgül",
  "imports.source.semicolon": "Noktalı virgül",
  "imports.source.tab": "Sekme",
  "imports.source.maxRecords": "En fazla kayıt",
  "imports.source.maxRecordsHint": "Tek önizlemede en fazla {{count}} kayıt bulunabilir.",
  "imports.placeholder.recordPath": "/items",
  "imports.placeholder.sourcePath": "/CONTENT",
  "imports.placeholder.titlePath": "/title",
  "imports.placeholder.constantPath": "/priority",
  "imports.target.title": "Hedef",
  "imports.target.description": "Tek bir standart kayıt türü seç. Kimlikleri ve sahipliği her zaman sunucu atar.",
  "imports.target.entity": "Kayıt türü",
  "imports.target.lifeSchema": "Yaşam şeması kimliği",
  "imports.target.lifeSchemaHint": "Yaşam kayıtları sana ait mevcut bir şema gerektirir.",
  "imports.mapping.title": "Alan eşlemesi",
  "imports.mapping.description": "Kaynak ve hedef alanları için JSON işaretçileri kullan. İçe aktarılan değerler yalnızca veri olarak işlenir.",
  "imports.mapping.sourcePath": "Kaynak yolu {{number}}",
  "imports.mapping.targetPath": "Hedef yolu {{number}}",
  "imports.mapping.transform": "Dönüşüm",
  "imports.mapping.removeBinding": "{{number}}. eşlemeyi kaldır",
  "imports.mapping.required": "Kaynak değeri zorunlu",
  "imports.mapping.default": "Eksikse varsayılan kullan",
  "imports.mapping.defaultValue": "Varsayılan değer",
  "imports.mapping.jsonValueHint": "Sayı, doğru/yanlış, dizi veya nesne için JSON gir; diğer metinler dize olarak kalır.",
  "imports.mapping.addBinding": "Alan ekle",
  "imports.mapping.addConstant": "Sabit ekle",
  "imports.constants.title": "Sabitler",
  "imports.constants.targetPath": "{{number}}. sabitin hedefi",
  "imports.constants.value": "{{number}}. sabitin değeri",
  "imports.constants.remove": "{{number}}. sabiti kaldır",
  "imports.transform.identity": "Olduğu gibi koru",
  "imports.transform.string": "Metin",
  "imports.transform.trim": "Kırpılmış metin",
  "imports.transform.integer": "Tam sayı",
  "imports.transform.number": "Sayı",
  "imports.transform.boolean": "Doğru veya yanlış",
  "imports.transform.date": "Tarih",
  "imports.transform.datetime": "Tarih ve saat",
  "imports.transform.string_list": "Metin listesi",
  "imports.preview.action": "Yükle ve önizle",
  "imports.review.title": "İçe aktarma incelemesi",
  "imports.review.description": "Önizleme hedef kayıtları yazmadı. Her kaynak alıntısını güvenilmeyen içe aktarılmış metin olarak oku.",
  "imports.review.file": "Dosya",
  "imports.review.records": "Kayıtlar",
  "imports.review.target": "Hedef",
  "imports.review.status": "Durum",
  "imports.review.validation": "{{count}} standart işlem önizleme doğrulamasını geçti.",
  "imports.status.refresh": "Durumu yenile",
  "imports.new": "Yeni içe aktarma",
  "imports.records.title": "Önerilen kayıtlar",
  "imports.records.description": "Uygulanacak satırları seç veya bu öneriden kalıcı olarak reddet.",
  "imports.record.selected": "Seçildi",
  "imports.record.accept": "Kabul et",
  "imports.record.accepted": "Kabul edildi",
  "imports.record.reject": "Reddet",
  "imports.dryRun.complete": "Kuru çalışma {{count}} işlem için geçti. Hedef kayıtlara yazılmadı.",
  "imports.dryRun.action": "Seçilenleri kuru çalıştır",
  "imports.apply.complete": "{{count}} işlem tek bir geri alınabilir makbuz olarak uygulandı.",
  "imports.apply.action": "Seçilenleri uygula",
  "imports.operation.queue": "Seçilenleri kuyruğa al",
  "imports.operation.cancel": "Kuyruktaki içe aktarmayı iptal et",
  "imports.operation.progress": "{{total}} kaydın {{current}} tanesi tamamlandı · %{{percent}}",
  "imports.operation.progressLabel": "Kuyruktaki içe aktarmanın ilerlemesi",
  "imports.operation.state.pending": "İçe aktarma kuyruğa alındı",
  "imports.operation.state.running": "İçe aktarma kaydediliyor",
  "imports.operation.state.cancel_requested": "İptal istendi",
  "imports.operation.state.cancelled": "Kuyruktaki içe aktarma iptal edildi",
  "imports.operation.state.succeeded": "İçe aktarma tamamlandı",
  "imports.operation.state.failed": "İçe aktarma güvenli biçimde başarısız oldu",
  "imports.operation.failed": "İşçi {{code}} kodunu döndürdü. Bu durumda özel kaynak içeriği saklanmadı.",
  "imports.undo.complete": "Uygulanan içe aktarma tek kapsam olarak geri alındı.",
  "imports.undo.action": "İçe aktarmayı geri al",
  "imports.selection.summary": "{{selected}} seçildi · {{pending}} bekliyor"
}
